import {postJson, post} from './http'
const baseUrl = '/api'

// 获取专题题库各板块的题库信息（章节练习/历年真题/模拟试题适用）
export const getTopicQuesBankInfoV2 = v => post(`${baseUrl}/capwhale/questionbank/questionbank/getTopicQuesBankInfoV2`, v.data, v.success, v.error, {}, true)
// 获取答题试题列表（章节练习/历年真题/模拟试题适用）
export const getQuestionListV2 = v => post(`${baseUrl}/capwhale/questionbank/questionbank/getQuestionListV2`, v.data, v.success, v.error, {}, true)
// 获取题库专题中某用户的做题记录
export const getTopicUserExamListV2 = v => postJson(`${baseUrl}/capwhale/questionbanktopic/getTopicUserExamListV2`, v.data, v.success, v.error)
// 提交专业题库购买
export const uploadTopicQuestionBankOrder = v => postJson(`${baseUrl}/capwhale/questionbanktopic/uploadTopicQuestionBankOrder`, v.data, v.success, v.error)
// 获取支付结果信息(专题题库用)
export const queryOrderPayResultByTopicQuestion = v => post(`${baseUrl}/capwhale/pay/queryOrderPayResultByTopicQuestion`, v.data, v.success, v.error)
// 收藏/取消收藏试题
export const saveTopicUserExamQuestionFavorite = v => postJson(`${baseUrl}/capwhale/questionbanktopic/saveTopicUserExamQuestionFavorite`, v.data, v.success, v.error)
// 取消错题
export const saveTopicUserExamQuestionError = v => postJson(`${baseUrl}/capwhale/questionbanktopic/saveTopicUserExamQuestionError`, v.data, v.success, v.error)
// 错题/收藏试题提交结果
export const saveTopicUserExamQuestionResultBySpecial = v => postJson(`${baseUrl}/capwhale/questionbanktopic/saveTopicUserExamQuestionResultBySpecial`, v.data, v.success, v.error)
// 获取我的收藏列表
export const getTopicUserExamFavoriteList = v => postJson(`${baseUrl}/capwhale/questionbanktopic/getTopicUserExamFavoriteList`, v.data, v.success, v.error)
// 获取我的错误集列表
export const getTopicUserExamErrorList = v => postJson(`${baseUrl}/capwhale/questionbanktopic/getTopicUserExamErrorList`, v.data, v.success, v.error)
// 提交开始做题 （来源收藏/错题，开始做题前需调用该接口清空数据）
export const updateTopicUserSpecialStartExam = v => postJson(`${baseUrl}/capwhale/questionbanktopic/updateTopicUserSpecialStartExam`, v.data, v.success, v.error)
// 获取我的收藏试题数据（分页获取，目前1页1道题）
export const getTopicUserExamFavoriteQuestionList = v => postJson(`${baseUrl}/capwhale/questionbanktopic/getTopicUserExamFavoriteQuestionList`, v.data, v.success, v.error)
// 获取我的错误集试题数据（分页获取，目前1页1道题）
export const getTopicUserExamErrorQuestionList = v => postJson(`${baseUrl}/capwhale/questionbanktopic/getTopicUserExamErrorQuestionList`, v.data, v.success, v.error)
// 获取我的收藏/错题试题数据答题卡
export const getTopicUserExamSpecialAnswerSheet = v => postJson(`${baseUrl}/capwhale/questionbanktopic/getTopicUserExamSpecialAnswerSheet`, v.data, v.success, v.error)
// 获取每日一练列表
export const getTopicUserExamDayTrainData = v => postJson(`${baseUrl}/capwhale/questionbanktopic/getTopicUserExamDayTrainData`, v.data, v.success, v.error)
// 开始每日一练做题（重新开始练习调用）
export const updateTopicUserExamDayTrainStartExam = v => postJson(`${baseUrl}/capwhale/questionbanktopic/updateTopicUserExamDayTrainStartExam`, v.data, v.success, v.error)
// 获取所有专题考试基本信息
export const getTopicQBBaseInfoAll = v => postJson(`${baseUrl}/capwhale/questionbanktopic/getTopicQBBaseInfoAll`, v.data, v.success, v.error)

